import Vue from 'vue';
import Vuex from 'vuex';
import { axios as request } from "../request/http";

// 资金商&服务商api
import base from "./modules/base";
// 资金商&服务商api
import merchant from "./modules/merchant";
// SKU平台管理
import stageInfo from "./modules/stageInfo";
// SKU管理
import skuInfo from "./modules/skuInfo";
// SPU
import productSpu from "./modules/productSpu";
// 属性管理
import productProperty from "./modules/property";
// 类目管理
import category from "./modules/category";
// 品牌管理
import brand from "./modules/brand";
// 标签管理
import label from "./modules/label";
// 资金商分组
import spGroup from "./modules/spGroup";
// 订单管理
import order from "./modules/order";
// 仓库管理
import warehouse from "./modules/warehouse";
// 角色管理
import roles from "./modules/roles"
// 角色管理
import product from "./modules/product"
// 用户权限
import permission from "./modules/permission"
// 门店管理
import shop from "./modules/shop"

import wallet from "./modules/wallet"

Vue.use(Vuex);

const interfaceUrl = {
    // 106.15.178.78:8888/eln-web-admin
    "api_uploadImage": "/base/file/publicUpload"
}

export default new Vuex.Store({
    state:{//状态
        menus: []
    },
    getters:{//状态计算
        getMenu: state => {
            return state.menus
        },
    },
    mutations:{
        SET_MENU: (state, pageData) => {
            state.menus = pageData;
        },
    },
    actions:{
        uploadImage: ({
            commit,
            state
        }, params) => {
            params = params || {};
            let option = {
                url: interfaceUrl.api_uploadImage,
                method: "POST",
                headers:{
                    "Content-Type": 'multipart/form-data'
                },
                data: params,
                params: {
                    scene: "SHOP"
                }
            };
            return request(option).then(res => res.data)
        },
        setMenu: ({
            commit,
            state
        }, menus) => {
            commit("SET_MENU", menus)
        },
    },
    modules: {
        base,
        merchant,
        stageInfo,
        skuInfo,
        productSpu,
        productProperty,
        category,
        brand,
        label,
        spGroup,
        order,
        warehouse,
        roles,
        product,
        permission,
        shop,
        wallet
        
    }  
})



// WEBPACK FOOTER //
// ./src/store/index.js